<div mat-dialog-title class="dialog-heading">
  {{ title }}
</div>

<div mat-dialog-content class="dialog-content" *ngIf="showMessage">
  <p>
    Item <b style="color: #6418c3">#INV-{{ clientId }}</b> will be moved to the
    <b style="color: #ffc806">{{ nextStage }}</b> stage. Are you sure you want
    to proceed?
  </p>
  <button
    mat-icon-button
    aria-label="Close"
    tabindex="-1"
    (click)="closeDialog()"
    class="btn-modal-close"
  ></button>
  <div *ngIf="showActive" class="flex-row-inline">
    <mat-checkbox color="primary" [(ngModel)]="activate">{{
      activeMessage
    }}</mat-checkbox>
  </div>
</div>

<div mat-dialog-actions class="dialog-actions">
  <button
    mat-button
    data-test-id="confirmation-no-btn"
    color="primary"
    class="confirm-button"
    (click)="confirm()"
    cdkFocusInitial
  >
    Proceed
  </button>
  <button
    mat-button
    class="deny-button"
    (click)="closeDialog()"
    data-test-id="confisrmation-yes-btn"
  >
    Cancel
  </button>
</div>
